// extracted by mini-css-extract-plugin
export default {"side":"LayoutWrapperAccountSettingsSideNav_side__OpLAZ"};